module.exports = __webpack_public_path__ + "img/pr-8.c94ad973.png";